
import Circle from './../../../zviz2/zviz/components/arc';
import Vector2 from './../../../zviz2/zviz/math/vector2';
import {extend, rgbToCss} from './../../../zviz2/zviz/functions';

let Blueprint = extend({
    properties: {
        attributes: {
            r: (ctrl) => (ctrl.data.r),
            cx: 0,
            cy: 0
        },
        style: {
            fill: (ctrl) => ( rgbToCss(ctrl.data.color) ),
            stroke: (ctrl) => ( (ctrl.data.hover || ctrl.data.active)? rgbToCss(ctrl.data.color): 'rgb(1,104,155)'),
            strokeWidth: '3.5px',
            fillOpacity: (ctrl) => ( (ctrl.data.hover || ctrl.data.active)? 1: 0),
            strokeOpacity: '1',
            cursor: 'pointer'
        },
        data: {
            r: 10,
            color: 'rgba(255,255,255,0)',
            opacity: 1
        }
    }
}, Circle);

export default Blueprint;